import React from 'react';
import { Link } from 'react-router-dom';
import { HiUserAdd } from 'react-icons/hi';
import { useUsers } from '../context/UsersContext';
export default function UsersHeader() {
  const { canManage } = useUsers();
  return <header className="flex flex-col gap-4 border-b border-gray-100 bg-white px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
    <div><h1 className="text-2xl font-bold text-slate-900">Users</h1>
      <p className="mt-1 text-sm text-slate-500">Manage user profiles, roles and account status.</p></div>
    {canManage && <Link to="/users/create" className="inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700">
      <HiUserAdd className="h-5 w-5" />Add New User</Link>}
  </header>;
}
